// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VuexStore from "./store";
import moment from 'moment';
import './verify.js';
//store
import store from "store";
Vue.prototype.$localStore = store;

//url
import config from "./config.js";
Vue.prototype.$url = config.url;

//ui
import elementUI from "element-ui";
import "./element-variables.scss";
import {number_format} from './filter';
Vue.use(elementUI);

//http
import http from "./http.js";
Vue.prototype.$http = http;

//PDF
import htmlToPDF from './toPDF.js';
Vue.use(htmlToPDF);

import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

const el_scrollBar = (el) => {
    if(el._ps instanceof PerfectScrollbar){
        el._ps.update()
    }else{
        el._ps = new PerfectScrollbar(el, {suppressScroll: true})
    }
}

Vue.directive('scrollBar', {
    //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
    inserted(el, binding, vnode) {
        //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
        //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
        //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
        const rules = ['fixed', 'absolute', 'relative']
        if(!rules.includes(window.getComputedStyle(el, null).position)){
            console.error(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`)
        }
        //el上挂一份属性
        el_scrollBar(el)
    },
    componentUpdated(el,binding, vnode, oldVnode){
        try{
            //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
            //故而也可以写成Vue.nextTick
            vnode.context.$nextTick(
                () => {
                    el_scrollBar(el)
                }
            )
        } catch (error) {
            console.error(error);
            el_scrollBar(el);
        }
    }
})

//二维码
import QRCode from 'qrcode';
Vue.prototype.$QRCode = function (url,options){
    let defaultOptions = {
        color: {
            dark: '#B9BED1',  // Blue dots
            light: '#F0F2F7' // Transparent background
        },
        width:123,
        height:123
    };
    options = {
        ...defaultOptions,
        ...options
    }
    return QRCode.toDataURL(url, options);
}
Vue.prototype.$moment = moment
Vue.prototype.$number = number_format

Vue.filter('moment', function (value, formatString) {
    if(value === "" || value === null || value === undefined){
        return "";
    }
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    // return moment(value).format(formatString); // value可以是普通日期 20170723
    return moment(value).format(formatString); // 这是时间戳转时间
});

//全局数字过滤
Vue.filter('number',number_format);

Vue.config.productionTip = false;

//全局样式
import "./global.scss";

//提示信息
Vue.prototype.$msg = function(type,content){
    this.$message({
        type:type,
        message:content,
    });
}


/* eslint-disable no-new */
new Vue({
    el: "#app",
    store: VuexStore,
    router,
    components: {
        App
    },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js